
/* global $, MACRAIL */

// Global setup

MACRAIL.defaultDatePickerOptions = {
    dateFormat: 'dd/mm/yy',
    showWeek: true,
    calculateWeek: function (date) { return date.getRailwayWeek(); },
    showOtherMonths: 'true',
    selectOtherMonths: 'true',
    changeMonth: true,
    changeYear: true,
    minDate: new Date(2006, 0, 1),
    firstDay: 6,
    controlType: ($(window).width() < 700 ? 'select' : 'slider')
};

MACRAIL.defaultSliderOptions = {
    range: "min",
    min: 0,
    max: 100,
    step: 1,
    slide: function (event, ui) {
        var parent = $(this).parent('div.form-group');
        parent.find('input:hidden').val(ui.value);
        parent.find('.slider-value').html(ui.value);
    }
};

// Report all JavaScript errors back to us
var addEvent =  window.attachEvent || window.addEventListener;
addEvent('error', function (e){
    var r = new XMLHttpRequest();
    r.open("POST", "scripts/appreporting.php?task=error", true);
    //r.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
    };

    var data = {
        "date": (new Date()).getFormatted('Y-m-d H:i:s'),
        "appname": "website",
        "version": "n/a",
        "type": "error",
        "language": "js",
        "message": e.message,
        "url": location.href,
        "line": e.lineno,
        "useragent": navigator.userAgent
    };

    if (e.colno) {
        data.column = e.colno;
    }

    var post = JSON.stringify(data);
    r.send(post);
});

$(document).ready(function () {
    // ----- MacRail Portal Menu -----
    var MacRailMenu = (function () {
        var $listItems = $('.menu > ul > li'),
            $menuItems = $listItems.children('a:not(.normal)'),
            searchBox = $('#header-search'),
            searchInput = $('#header-search-input'),
            searchButton = $('#header-search-button'),
            searchUrl = $('#header-search-url'),
            searchToggle = $('.mobile-search-toggle'),
            menuToggle = $('.mobile-menu-toggle'),
            searchAjaxDelay = 0,
            $body = $('body'),
            current = -1;

        function init() {
            $menuItems.on('click', open);
            $listItems.on('click', function (event) { event.stopPropagation(); });
        }

        function open(event) {
            // Opening a new Menu, so we need to hide the old one
            if (current !== -1) {
                $listItems.eq(current).removeClass('open').children('.sub').slideUp();
            }

            var $item = $(event.currentTarget).parent('li'),
                idx = $item.index();

            if(current === idx) {
                // Menu has got to go
                $item.removeClass('open').children('.sub').slideUp();
                current = -1;
            } else {
                // Show the menu
                $item.addClass('open').children('.sub').slideDown();
                current = idx;

                // Click on the body so menu is closed
                $body.off('click').on('click', close);

                // On mobile don't close on scroll
                if ($(window).width() > 768) $(document).on('scroll', close);
            }
            return false;
        }

        function close (event) {
            $listItems.eq( current ).removeClass('open');
            $listItems.eq( current ).children('.sub').slideUp();
            current = -1;
        }

        function hideSearch () {
            if(searchInput.val() != '') {
                return;
            }
            setTimeout(function () {
                searchInput.blur();
            }, 300);
        }

        searchBox.on('click', function (e) {
            // Stop click reaching document
            e.stopPropagation();
        });

        function searchDoAjax() {
            // Don't search for strings that are 3 characters or less
            if (searchInput.val().length <= 3) return false;

            $('#menu-search-results').html('<div class="menu-search-loading-text">Searching for Events...</div>');

            $('#menu-search-results').load('ajax/menu-search.php', { search: searchInput.val() });

            LogAction([{
                type: 6,
                task: 'menu-search',
                item: searchInput.val()
            }][0]);

            if ($('#menu-search').children('.sub').css("display") == "none") {
                $('#menu-search').show().children('a').trigger('click');
            }
        }

        searchInput.on('keyup', function(e) {
            var code = e.keyCode || e.which;

            clearTimeout(searchAjaxDelay);

            if (code == 13 && ($(window).width() <= 900 || $("html").hasClass("ie7"))) {
                location.href = searchUrl.val() + '&item=' + searchInput.val();
                return false;
            }

            if (!$(window).width() <= 900) {
                searchAjaxDelay = setTimeout(searchDoAjax, 800);
            }

        });

        searchInput.on('keydown', function(e) {
            clearTimeout(searchAjaxDelay);
        });


        searchButton.on('click', function(e) {
            if ($(window).width() > 900 && !$("html").hasClass("ie7")) {
                searchDoAjax();
            } else {
                location.href = searchUrl.val() + '&item=' + searchInput.val();
            }
        });

        searchToggle.on('click', function(e) {
            searchBox.toggleClass('active');
            searchToggle.toggleClass('active');
        });

        menuToggle.on('click', function(e) {
            $('#menu').toggleClass('active');
            menuToggle.toggleClass('active');
        });


        // If we click the document, hide search and menu
        // Make sure any click events to open the search are menu are cancelled with stopPropagation
        // or this will immediately fire and close it again!
        $(document).on('click', function(e) {
            searchInput.val('');
            hideSearch();
        });
        return { init : init };
    })();

    MacRailMenu.init();

    $('.forceuppercase')
    .on('input', function() {
        if (this.value.length > 0) {
            this.style.textTransform = 'uppercase';
        } else {
            this.style.textTransform = '';
        }
    })
    .on('change', function() {
        this.value = this.value.toLocaleUpperCase();
    });

    $('.autoselectbrackets').on('mouseup tap', function() {
        var selStart = this.selectionStart;
        var selEnd = this.selectionEnd;

        var newStart = -1;
        var newEnd = -1;

        if (selStart == selEnd) {
            for (var i=1; i<35; i++) {
                if (this.value.charAt(selStart - i) == ']') break;
                if (this.value.charAt(selStart - i) == '[') { newStart = selStart - i; break; }
            }
            for (var i=0; i<35; i++) {
                if (this.value.charAt(selEnd + i) == '[') break;
                if (this.value.charAt(selEnd + i) == ']') { newEnd = selEnd + i + 1; break; }
            }
            if (newStart != -1 && newEnd != -1) {
                this.selectionStart = newStart;
                this.selectionEnd = newEnd;
            }
        }
    });

    // ----- Stick form footer

    var $stickyElements = $('.sticky-element');

    $stickyElements.each(function(i, el) {
        var $element = $(el);
        var $parent = $element.parent();
        var elementHeight = $element.outerHeight(true);
        var placeHolder = $('<div />').insertAfter($element);
        var shouldStickOld = false;
        var bottomPosOld = 0;

        function calcStickiness() {
            var scrollPos = $(window).scrollTop();
            var viewportHeight = $(window).height();
            var placeHolderPos = placeHolder.offset().top;
            var pos = (placeHolderPos + placeHolder.height()) - scrollPos - viewportHeight;
            var shouldStick = pos > 0;

            var bottomPos = Math.min(0, viewportHeight - ($parent.offset().top - scrollPos) - 200);
            if (bottomPos != bottomPosOld) {
                $element.css({
                    bottom: bottomPos + 'px'
                });
                bottomPosOld = bottomPos;
            }

            if (shouldStick) {
                $element.css({ width: $element.parent().css('width') });
            }

            if (shouldStick != shouldStickOld) {
                shouldStickOld = shouldStick;
                if (shouldStick) {
                    placeHolder.css({
                        height: elementHeight + 'px',
                    });
                    $element.addClass('sticky-element-stuck')
                } else {
                    placeHolder.css({height: ''});
                    $element.removeClass('sticky-element-stuck');
                    $element.css({ width: '' });
                }
            }
        }
        $(document).on('scroll', calcStickiness);
        $(window).on('resize', calcStickiness);
        calcStickiness();
    });


    // ----- Bootstrap - Tooltips & Popovers -----
    $(document).on("mouseenter",'[data-toggle="popover"]',function(e) {
        $(this).popover({trigger: 'click', html : true });
    });

    $(document).on("mouseenter",'[data-toggle="tooltip"]',function(e){
        if ($(this).hasClass('diary-timeline-entry')) { // For the diary timeline skip the tooltip on touch devices
            if ('ontouchstart' in document.documentElement) {
                e.preventDefault();
            }
        }
        $(this).tooltip({ html : true }).tooltip('show');
    });

    $('body').on('click', function (e) {
        $('[data-toggle="popover"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });

    // ----- File Uploading - Providing Feedback for the User -----
    $(document).on('change', '.btn-file :file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });

    $('.btn-file :file').on('fileselect', function(event, numFiles, label) {
        var input = $(this).parents('.input-group').find(':text'),
            log = numFiles > 1 ? numFiles + ' files selected' : label;

        if( input.length ) {
            input.val(log);
        } else {
            if( log ) alert(log);
        }
    });


    // ----- Modal creation for displaying uploaded pictures -----
    $(document).on('click', '.picture-modal', function() {
        if ($('#pictureModal').length) $('#pictureModal').remove();

        createModalTemplate('pictureModal', {
            Title: $(this).attr('title') || 'Picture'
        });

        var src = $(this).attr('data-fullurl');
        if (src == undefined || src == '') {
            src = $(this).attr('href');
        }
        var description = $(this).attr('data-desc') || '';

        $('#pictureModal .modal-content').append('<div class="modal-body"><div style="text-align:center;"><img style="max-width:100%;" src="' + src + '"></div><p style="margin:0;">' + description + '</p></div>');

        $('#pictureModal').modal({ keyboard: true, backdrop: "static"}).modal('show');

        return false;
    });

    // ----- QR codes for phone numbers ----


    $(document).on('click', '.phoneqrcode', function(e) {
        $this = $(this);

        $content = $('<div>If you have a mobile with a QR-Code scanner, scan the below code to call the person.<br /><br /><div></div></div>');

        var qrcode = new QRCode($content.find('div')[0], {
            text: $this.parent().find('a').attr('href'),
            width: 180,
            height: 180,
            colorDark : "#123",
            colorLight : "#fff",
            correctLevel : QRCode.CorrectLevel.L
        });

        $this.qtip({
            content: {
                text: $content
            },
            style: {
                classes: 'qtip-light qtip-shadow',
                width: '200px'
            },
            position: {
                my: 'top middle',
                at: 'bottom middle',
                adjust: {
                    y: 5
                }
            },
            show: {
                event: false,
                when: false,
                ready: true
            },
            hide: 'unfocus'
        });
    });

    // ----- Toggle Pannel Icons -----
    function toggleChevron(e) {
        $(e.target).prev('.panel-heading').find('a[data-toggle="collapse"] .fa').toggleClass('fa-chevron-down fa-chevron-up');
    }

    $('body').on('hidden.bs.collapse', '.panel-group', toggleChevron);
    $('body').on('shown.bs.collapse', '.panel-group', toggleChevron);


    // ----- Auto Select Content -----
    $(document).on('click', '.autoselectcontent', function() {
        var range, selection;
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(this);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(this);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    });

    // ----- To Top Link -----
    $(document).ready(function ($) {
        if ($(window).width() > 768) {
            // browser window scroll (in pixels) after which the "back to top" link is shown
            var offset = 300,
            //duration of the top scrolling animation (in ms)
            scroll_top_duration = 700,
            //grab the "back to top" link
            $back_to_top = $('.to-top-link');

            //hide or show the "back to top" link
            $(window).scroll(function() {
                ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('to-top-link-visible') : $back_to_top.removeClass('to-top-link-visible');

            });

            //smooth scroll to top
            $back_to_top.on('click', function(event){
                event.preventDefault();
                $('body,html').animate({scrollTop: 0}, scroll_top_duration);
            });
        }
    });

    // ----- Help Tours -----
    $('body').on('click', '.create-help', function () {
        var parameters = [{
                type: 1,
                task: $(this).attr('data-help'),
                item: $(this).attr('data-element'),
                event: $(this).attr('data-event'),
                user: $(this).attr('data-user'),
                show: $(this).attr('data-show'),
                multiHelp: $(this).attr('data-multiple'),
                multiItems: $(this).attr('data-mutltipleitems'),
                content: parseFloat($(this).attr('data-version')),
                userversion: parseFloat($(this).attr('data-userversion')),
                version: parseFloat($(this).attr('data-version'))
            }];
        parameters = parameters[0];
        JSLoading('assetlibs/introjs/intro.js', function () { getHelpGuide(parameters); });
    });

    if ($('#product-update-button').length) {
        window.announcekit = (window.announcekit || { queue: [], on: function(n, x) {
            window.announcekit.queue.push([n, x]); }, push: function(x) { window.announcekit.queue.push(x); }
        });

        var announcekitLabels = [
            "Worksite360",
        ];

        var announceKitElement = $('.announcekit-widget');

        var info = JSON.parse(announceKitElement.attr('data-info'));

        var data = {
            ...{
                "widget"   : "https://announcekit.co/widgets/v2/" + announceKitElement.attr('data-id'),
                "selector" : ".announcekit-widget",
                badge: {
                    style: {
                        'width': '1em',
                        'height': '1em',
                        'position': 'absolute',
                        'vertical-align': 'middle',
                        'visibility': 'visible',
                        'font-size': '20px',
                        'top': '0',
                        'right': '0'
                    }
                }
            },
            ... info
        };

        window.announcekit.push(data);
    }

    // ----- Toolbar Resizing -----
    toolbarResizing();

    var resizeId;
    $(window).resize(function() {
        clearTimeout(resizeId);
        resizeId = setTimeout(toolbarResizing, 100);
    });

    $('.recognise').each(function() {
        var $this = $(this);

        var postCodeRegex = /(((([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) [0-9][ABD-HJLNP-UW-Z]{2}))/g;

        $this.html($this.html().replace(postCodeRegex, '<span class="recognise-item recognise-type-postcode">$&</span>'));

    });

    $(document).on('click', '.recognise-item', function() {
        var $this = $(this);

        var postCode = $this.text();

        var imageScale = window.devicePixelRatio < 1.5 ? 1 : 2;

        var mapsUrl = 'https://maps.google.com?q=' + postCode;

        var modal = $this.data('recognise-modal');
        if (modal == undefined) {
            modal = new MACRAIL.Modal({
                buttons: [{
                    'name': 'close',
                    'role': 'dismiss',
                    'text': 'Close',
                }],
                title: 'Map for ' + postCode,
                body: '<img src="https://maps.googleapis.com/maps/api/staticmap?key=' + PAGEVARS.GoogleApiKeyStaticMaps + '&size=570x420&zoom=12&scale=' + imageScale + '&markers=color:red|' + encodeURIComponent(postCode) + '" style="max-width: 570px;" /><br /><br /><a href="' + mapsUrl + '" target="_blank">Open in Google Maps</a>'
            });

            $this.data('recognise-modal', modal);
        }

        modal.show();
    });

    $('body').on('input blur', 'input.price', function() {
        var val = $(this).val();
        $(this).val(val.replace(/[^\d.,]/g, ''));
    });
});

function parseHelpJson(response, object) {
    var content = $.grep(response, function (obj, index) {
        if (object.show === 'new' || object.show === 'multi-new') {
            obj.intro = '<p style="font-size:12pt"><strong>New!</strong></p>' + obj.intro;
            return (obj.version > object.userversion);
        }
        if (object.item !== undefined) {
            if (obj.parent !== undefined && obj.parent == object.item) {
                return ($(obj.element).length && $(obj.element).is(':visible'));
            } else {
                return (object.item === obj.element && $(obj.element).length && $(obj.element).is(':visible'));
            }
        } else {
            return (typeof obj.element == 'undefined') || ($(obj.element).length && $(obj.element).is(':visible'));
        }
    });
    return content;
}

function getHelpGuide(parameters) {
    if (parameters.multiHelp == 1) {
        parameters.content = '';

        var userObj = $.parseJSON(parameters.multiItems);
        var requests = [];
        var helpObjects = [];

        $.each(userObj, function (key, value) {
            var path = 'pieces/tours/' + value.name + '.json';

            helpObjects.push({
                show: parameters.show,
                userversion: parseFloat(value.userVersion),
                version: parseFloat(value.helpVersion)
            });

            requests.push($.getJSON(path));

            if (parameters.show === 'multi-new' || parameters.show === 'multi-all') {
                $.post('ajax/user-meta.php', {
                    type: value.name,
                    user: parameters.user,
                    value: value.helpVersion
                });
            }
        });

        $.when.apply(null, requests).then(function() {
            var returnedData = [];
            $.each(arguments, function(i, row) {
                var status = row[1],
                data = row[0];

                if (status === 'success') {
                    if (parseFloat(helpObjects[i].userversion) == parseFloat(helpObjects[i].version) && parameters.show === 'multi-all') {
                        return;
                    }

                    var content = parseHelpJson(data, helpObjects[i]);

                    if (!content.length) {
                        return false;
                    }

                    if (parameters.item !== undefined && content[0].subtour != undefined) {
                        $.each(content[0].subtour, function (key, value) {
                            content.push(value);
                        });
                    }

                    returnedData =  $.merge(returnedData, content);
                }
            });

            if (!returnedData.length) {
                return false;
            }

            runHelp(parameters, returnedData);
        });

    } else {
        var path = 'pieces/tours/' + parameters.task + '.json';
        var returnedData = [];
        $.getJSON(path, function(response) {
            returnedData = parseHelpJson(response, parameters);

            if (!returnedData.length) {
                return false;
            }

            if (parameters.show === 'new' || parameters.show === 'all') {
                $.post('ajax/user-meta.php', {
                    type: parameters.task,
                    user: parameters.user,
                    value: parameters.version
                });
            }

            if (parameters.item !== undefined && returnedData[0].subtour != undefined) {
                $.each(returnedData[0].subtour, function (key, value) {
                    returnedData.push(value);
                });
            }
            if (!returnedData.length) {
                return false;
            }

            runHelp(parameters, returnedData);
        });
    }
}

function runHelp(parameters, returnedData) {
    var guide = introJs();
        guide.setOptions({
            steps: returnedData,
            showBullets: returnedData.length > 1 ? true : false,
            showStepNumbers: returnedData.length > 1 ? true : false,
            scrollToElement: false,
            disableInteraction: true,
            tooltipPosition: 'auto'
        });
        var exit = (exit == undefined ? false : exit);
        var complete = (complete == undefined ? false : complete);
        guide.oncomplete(function () {
            if (!complete) {
                parameters.status = 'completed';
                LogAction(parameters);
                complete = true;
            }
        });
        guide.onexit(function () {
            if (!exit && !complete) {
                parameters.status = 'quit';
                LogAction(parameters);
                exit = true;
            }
        });
        guide.start();
}

function LogAction(parameters) {
    $.post('ajax/user-action.php', {
        user: (parameters.user === undefined ? null : parameters.user),
        type: parameters.type,
        task: parameters.task,
        item: (parameters.item === undefined ? null : parameters.item),
        status: (parameters.status === undefined ? null : parameters.status),
        event: (parameters.event === undefined ? null : parameters.event),
        content: (parameters.content === undefined ? null : parameters.content),
    });
}

function toolbarResizing() {
    var windowwidth = $(window).width();

    if ($('.macrail-toolbar-normal').length == 0) return true;

    $('.macrail-toolbar-normal').each(function() {
        var toolbar = $(this),
            toolbarid = $(this).attr('id'),
            toolbargroups = toolbar.find('.btn-group').not('.macrail-toolbar-toggle'),
            grouptotal = toolbar.attr('data-groups'),
            mobilemenutoggle = toolbar.find('.macrail-toolbar-toggle'),
            mobilemenu = $('#'+ toolbarid + '-mobile'),
            mobilemenulinks = mobilemenu.children().length,
            hiddenlinks = 0;

        if (!toolbar.attr('data-mobile') && windowwidth > 768) { // Resize only when window is below 768 and toolbar isn't already mobile
            return true;
        }

        if (mobilemenulinks == 0 && windowwidth <= 768) { // Mobile Menu has no children yet, so look for some
            $(toolbargroups).children('.macrail-toolbar-desktop').each(function() {
                var link = $(this),
                    copy = link.clone(),
                    list = $('<li>');

                link.addClass('btn-hidden');
                copy.removeClass().removeAttr('style');

                list.append(copy);
                list.appendTo($('#'+ toolbarid + '-mobile'));

                hiddenlinks++;
            });
        }

        if ((mobilemenulinks > 0 || hiddenlinks > 0) && windowwidth <= 768) {
            $(toolbar).attr('data-mobile', true);
            $(mobilemenutoggle).addClass('active');
        }

        $(toolbargroups).not('.btn-group-justified').each(function() {
            var group = $(this),
                childlinks = parseInt(group.attr('data-buttons')),
                hiddenlinks = group.find('.btn-hidden').length;

            if (windowwidth <= 768) { // Adjust the button width based on the number of buttons
                if (hiddenlinks === childlinks) { // Hide Parent group when there are no links to be displayed
                    group.hide();
                }
                var button = (childlinks - hiddenlinks);
                group.find('.button-'+childlinks).removeClass('button-'+childlinks).addClass('button-'+button);
                group.attr('data-buttons-mobile', button);

                toolbar.find('.btn-group').filter(':visible').css('width', 100 / toolbar.find('.btn-group').filter(':visible').not('.btn-group-justified').length + '%');
            } else {
                group.show();
                group.css('width', '');
                if (group.hasClass('btn-group-justified')) {
                    group.css('display', '');
                    return true;
                }
                var mobile = group.attr('data-buttons-mobile');
                group.find('.button-'+mobile).removeClass('button-'+mobile).addClass('button-'+childlinks);
            }
        });
    });
};



// ----- Helper functions -----

function createDate(sqldate) {
    var d = new String(sqldate);
    d = d.replace(/[^0-9]/g, ' ');
    d = d.split(' ');

    if (d.length==5) {
        d[5]=0;
    }

    // if the 3rd position is a large number, assume English-formatted date (01/02/2015) and swap with first position.
    if (d[2] > 40) {
        var temp = d[0];
        d[0] = d[2];
        d[2] = temp;
    }

    return new Date(d[0],d[1]-1,d[2],d[3],d[4],d[5]);
}

Date.prototype.getRailwayWeek = function () {
    var date = this;

    // Get the earlist day for given date, and find the next saturday
    var sat;
    if (date.getFullYear() == 2020) {
        sat = new Date(2020, 3, 4);
    } else {
        sat = new Date(date.getFullYear(), 3-1, 28);
    }
    sat.setDate(sat.getDate() + (6 - sat.getDay()));

    // If the earliest day is after the given date, recalculate from last year
    if (sat > date) {
        if (date.getFullYear() == 2021) {
            sat = new Date(2020, 3, 4);
        } else {
            sat = new Date(date.getFullYear() - 1, 3-1, 28);
        }
        sat.setDate(sat.getDate() + (6 - sat.getDay()));
    }

    // Get different and convert to weeks
    var diff = date.getTime() - sat.getTime();
    diff = Math.round(diff/86400000/7) + 1;

    return diff;
};

Date.prototype.getFormatted = function (text) {
    var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var monthNames = ['January','February','March','April','May','June',
                      'July','August','September','October','November','December'];
    var ordinals = ['', 'st','nd','rd','th','th','th','th','th','th','th',
                        'th','th','th','th','th','th','th','th','th','th',
                        'st','nd','rd','th','th','th','th','th','th','th',
                        'st'];

    var result = '';
    var char;

    for (var i=0;i<text.length;i++) {
        char = text.substr(i,1);
        switch (char) {
        case '\\': i++; char = text.substr(i,1); break;
        case 'j': char = this.getDate(); break;
        case 'd': char = ((this.getDate() < 10 ? '0' : '')+this.getDate()).substr(-2); break;
        case 'D': char = dayNames[this.getDay()].substr(0,3); break;
        case 'l': char = dayNames[this.getDay()]; break;
        case 'N': char = '#'; break;
        case 'S': char = ordinals[this.getDate()]; break;
        case 'w': char = this.getDay(); break;
        case 'z': char = '#'; break;
        case 'W': char = '#'; break;
        case 'F': char = monthNames[this.getMonth()]; break;
        case 'm': char = (((this.getMonth() + 1) < 10 ? '0' : '')+(this.getMonth() + 1)).substr(-2); break;
        case 'M': char = monthNames[this.getMonth()].substr(0,3); break;
        case 'n': char = this.getMonth()+1; break;
        case 't': char = '#'; break;
        case 'L': char = '#'; break;
        case 'o': char = '#'; break;
        case 'Y': char = this.getFullYear(); break;
        case 'y': char = this.getFullYear().toString().substr(2); break;
        case 'a': char = '#'; break;
        case 'A': char = '#'; break;
        case 'B': char = '#'; break;
        case 'g': char = '#'; break;
        case 'G': char = this.getHours(); break;
        case 'h': char = '#'; break;
        case 'H': char = ((this.getHours() < 10 ? '0' : '')+this.getHours()).substr(-2); break;
        case 'i': char = ((this.getMinutes() < 10 ? '0' : '')+this.getMinutes()).substr(-2); break;
        case 's': char = ((this.getSeconds() < 10 ? '0' : '')+this.getSeconds()).substr(-2); break;
        case 'u': char = ((this.getMilliseconds() < 10 ? '00' : '')+this.getMilliseconds()).substr(-3); break;
        case 'e': char = '#'; break;
        case 'I': char = '#'; break;
        case 'O': char = '#'; break;
        case 'P': char = '#'; break;
        case 'T': char = '#'; break;
        case 'Z': char = '#'; break;
        case 'c': char = this.getFormatted('Y-m-d\\TH:i:sP'); break;
        case 'r': char = this.getFormatted('D, j M Y H:i:s O'); break;
        case 'U': char = this.getTime(); break;
        }
        result += char;
    }
    return result;
}

function setFieldValue(id, value) {
    var field = $('#' + id);

    var oldValue = field.val();

    field.val(value);

    if (field.is('select') && field.val() == null) {
        field.val(oldValue);
        alert('Sorry - the field cannot be set to that value. Perhaps that item is no longer available (e.g. a Company has now been deleted).');
        return false;
    }

    field.trigger('change');
    return false;
}

// ----- Create Modal Template -----
function createModalTemplate(id, attr) {
    // Default Attributes
    attr = $.extend({
        DialogSize: '',
        HeaderClass: '',
        Title: '',
        ShowClose: true,
        Container: $('#content-container')
    }, attr || {});

    // Modal already Exists
    if ($('#'+id).length > 0) {
        // Update Title
        $('#'+id+' .modal-title').html(attr.Title);
        // Remove Previous Content
        $('#'+id+' .modal-body').remove();
        $('#'+id+' .modal-footer').remove();
        return;
    }
    // Create Modal Elem
    var modal = $('<div>').attr({id: id,tabindex: '-1', role: 'dialog', 'aria-labelledby': id, 'aria-hidden': true}).addClass('modal fade'),
        dialog = $('<div>').addClass('modal-dialog ' + attr.DialogSize),
        content = $('<div>').addClass('modal-content'),
        header = $('<div>').addClass('modal-header ' + attr.HeaderClass),
        title = $('<h4>').addClass('modal-title').html(attr.Title),
        closeButton = $('<button>').attr({type:'button', 'data-dismiss': "modal", 'aria-hidden': true}).addClass('close').html('<i class="fa fa-times"></i>');

        if (attr.ShowClose) header.append(closeButton);
        header.append(title);
        content.append(header);
        dialog.append(content);
        modal.append(dialog);

    // Add it to the Content Container
    attr.Container.append(modal);
}

function setModalAlert(id, className, html) {
    var $modal = $('#' + id);
    var $modalBody = $modal.find('.modal-body');
    var $modalAlert = $modalBody.find('.modal-alert');

    if ($modalAlert.length == 0) {
        $modalBody.prepend('<div class="modal-alert alert" style="margin-bottom: 15px;"></div>');
        $modalAlert = $modalBody.find('.modal-alert');
    }
    $modalAlert.prop('class', 'modal-alert alert alert-' + className);
    $modalAlert.html(html);
}

jQuery.fn.setAlertClass = function(className) {
    var alertClasses = 'alert-default alert-info alert-success alert-warning alert-danger alert-primary alert-secondary';
    var btnClasses   = 'btn-default btn-info btn-success btn-warning btn-danger btn-primary btn-secondary';
    var highlightClasses = 'highlight-default highlight-info highlight-success highlight-warning highlight-danger highlight-primary highlight-secondary';

    this.removeClass(alertClasses).addClass('alert-' + className);

    var button = this.find('.alert-button');
    if (button.length > 0) {
        button.removeClass(btnClasses).addClass('btn-' + className)
    }

    var highlight = this.find('.highlight');
    if (highlight.length > 0) {
        highlight.removeClass(highlightClasses).addClass('highlight-' + className)
    }

    return this;
}

// ----- Dynamic Loading of JS -----
function JSLoading (path, callback) {
    var exists = document.querySelector("script[src*='"+path+"']");

    if (exists === null) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = path;

        script.onreadystatechange = function () {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
                if (callback instanceof Function) {
                    callback();
                }
            }
        };

        script.addEventListener('load', function() {
            if (callback instanceof Function) {
                setTimeout(() => {
                    callback();
                }, 0);
            }
        });

        document.body.appendChild(script);

    } else {
        if (callback instanceof Function) {
                callback();
        }
    }
}
